import type { FunctionComponent } from 'react';
import { css } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import DocumentTitle from './DocumentTitle';
import Headline from './Headline';
import Highlights from './Highlights';
import PermissionsBullets from './PermissionsBullets';
import NonPermissionsBullets from './NonPermissionsBullets';
import BoardsAndWorkspaces from './BoardsAndWorkspaces';
import AccessGate from './AccessGate/AccessGate';

const Trello: FunctionComponent = () => {
  return (
    <AccessGate>
      <DocumentTitle />
      <Stack alignInline="center" space="space.200">
        <Headline logoUrl={''} />
        <Separator />
        <Highlights />
        <Separator />
        <Stack space="space.400">
          <PermissionsBullets />
          <NonPermissionsBullets />
          <BoardsAndWorkspaces />
        </Stack>
        <Separator />
      </Stack>
    </AccessGate>
  );
};

const separatorStyle = css({
  borderColor: token('color.border'),
  width: '100%',
});

const Separator = () => <hr css={separatorStyle} role="presentation" />;

export default Trello;
